export default __webpack_public_path__ + "static/media/jntua-k.9fb6b9b2.jpg";